"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var defaultConfig = {
    apiType: 'private',
    assertStatusCodes: [200, 400],
    method: 'GET',
    microserviceName: 'offerCard',
    pathApi: '/v1/get-offer-data/',
};
function createGetOfferDataModel(config) {
    return __assign({}, defaultConfig, config);
}
exports.createGetOfferDataModel = createGetOfferDataModel;
var EHeatingType;
(function (EHeatingType) {
    /** Есть */
    EHeatingType["Has"] = "has";
    /** Не указано */
    EHeatingType["None"] = "none";
    /** Нет (без отопления) */
    EHeatingType["Without"] = "without";
    /** Центральное газовое */
    EHeatingType["Gas"] = "gas";
    /** Центральное угольное */
    EHeatingType["Coal"] = "coal";
    /** Печь */
    EHeatingType["Stove"] = "stove";
    /** Камин */
    EHeatingType["Fireplace"] = "fireplace";
    /** Электрическое */
    EHeatingType["Electric"] = "electric";
    /** Автономное */
    EHeatingType["Autonomous"] = "autonomous";
    /** Котел | Квартирное отопление (квартирный котел) */
    EHeatingType["Boiler"] = "boiler";
    /** Центральное отопление */
    EHeatingType["Central"] = "central";
    /** Другое */
    EHeatingType["Other"] = "other";
    /** Автономное газовое */
    EHeatingType["AutonomousGas"] = "autonomousGas";
    /** Дизельное */
    EHeatingType["Diesel"] = "diesel";
    /** Твердотопливный котел */
    EHeatingType["SolidFuelBoiler"] = "solidFuelBoiler";
    /** Индивидуальный тепловой пункт (ИТП) */
    EHeatingType["ITP"] = "itp";
    /** Индивидуальный тепловой пункт (ИТП) */
    EHeatingType["GasWaterHeater"] = "gasWaterHeater";
    /** Автономная котельная (крышная, встроенно-пристроенная) */
    EHeatingType["AutonomousBoiler"] = "autonomousBoiler";
})(EHeatingType = exports.EHeatingType || (exports.EHeatingType = {}));
var EOverhaulFundType;
(function (EOverhaulFundType) {
    /** Не известно */
    EOverhaulFundType["Unknown"] = "unknown";
    /** На счете регионального оператора */
    EOverhaulFundType["RegionalOp"] = "regionalOp";
    /** На специальном счете организации */
    EOverhaulFundType["SpecialOrg"] = "specialOrg";
    /** На специальном счете у регионального оператора */
    EOverhaulFundType["SpecialRegionalOp"] = "specialRegionalOp";
    /** Не определён */
    EOverhaulFundType["Undefined"] = "undefined";
})(EOverhaulFundType = exports.EOverhaulFundType || (exports.EOverhaulFundType = {}));
var EGasSupplyType;
(function (EGasSupplyType) {
    /** Не известно */
    EGasSupplyType["Unknown"] = "unknown";
    /** Автономное */
    EGasSupplyType["Autonomous"] = "autonomous";
    /** Центральное */
    EGasSupplyType["Central"] = "central";
    /** Отсутствует */
    EGasSupplyType["Without"] = "without";
})(EGasSupplyType = exports.EGasSupplyType || (exports.EGasSupplyType = {}));
var EOverlapType;
(function (EOverlapType) {
    /** Не известно */
    EOverlapType["Unknown"] = "unknown";
    /** Деревянные */
    EOverlapType["Wood"] = "wood";
    /** Железобетонные */
    EOverlapType["Concrete"] = "concrete";
    /** Смешанные */
    EOverlapType["Mixed"] = "mixed";
    /** Иные */
    EOverlapType["Other"] = "other";
})(EOverlapType = exports.EOverlapType || (exports.EOverlapType = {}));
//# sourceMappingURL=get-offer-data.js.map